import { Form } from 'antd';
import { useContext, useMemo } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { PicturesComponent } from 'app/components/commons/Room/Pictures/Pictures';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useRoomCategories } from 'app/hooks/data/rooms/useRoomCategories';

export const Pictures = () => {
  const form = Form.useFormInstance();
  const formValues = Form.useWatch([], form);
  const { data: roomCategories } = useRoomCategories();
  const { isEditMode } = useContext(ViewEditModeContext);

  const categories = useMemo(() => {
    const map: { [key: number]: string } = {};

    roomCategories?.forEach((cat) => {
      map[cat.id] = cat.name;
    });

    return map;
  }, [roomCategories]);

  if (!formValues) {
    return null;
  }

  return (
    <SCard
      title="Photos"
      subtitle="In edit mode, you can drag and drop photos to rearrange them. The first one will be the room cover"
      className="room-detail__last-card"
    >
      <Form.Item name="pictures">
        <PicturesComponent
          value={formValues.pictures}
          roomCategoryId={formValues.categoryId}
          categories={categories ?? []}
          hotelId={formValues?.hotelId}
          picturesCategories={[
            { name: 'Official', type: 'official' },
            { name: 'Sourcing', type: 'sourcing' },
          ]}
          kind="sourcing"
          draggable={isEditMode}
          previewable
          removable={isEditMode}
          disabled={!isEditMode}
        />
      </Form.Item>
    </SCard>
  );
};
